import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0302 from "../lesson-02/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "777fd473-a9b1-4e8e-b00f-268eb5bf2698",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0302),
    lesson: lesson0302,
  },
];

export default lessonLinks;
